import { whiteColor } from '../global';

const SettingSellProductOrganizerStyle = () => ({
    wrapper: {
        backgroundColor: whiteColor,
    },
    title: {
        padding: '32px 0',
    },
    items: {
        margin: '15px 0',
    },
    itemsInfo: {
        margin: '15px 0 15px 50px',
    },
    currencyInput: {
        '& input': {
            padding: '9px',
            width: '333px',

            '&::-webkit-inner-spin-button': {
                opacity: 1, // Always show spin buttons on Chrome
            },
        },
    },
    numberInput: {
        width: '150px',
    },
    price: {
        '&:after': {
            content: '"円"',
            transform: 'translateX(calc(100% + 10px))',
        },
    },
    detailItem: {
        display: 'flex',
        flexDirection: 'column',
    },
    detailItemChild: {
        display: 'flex',
        flexDirection: 'column',

        '& input': {
            padding: '7px',
        },
    },
});

export default SettingSellProductOrganizerStyle;
